// extracted by mini-css-extract-plugin
export default {"lanyardWrapper":"Lanyard_lanyardWrapper__+59K2","canvasContainer":"Lanyard_canvasContainer__dkFKU","dragging":"Lanyard_dragging__Ez1-o"};